import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    newsReaction: {},
    showCommentModal: false,
    commentId: null,
};

export const newsSlice = createSlice({
    name: 'news',
    initialState,
    reducers: {
        setNewsReaction: (state, action) => {
            state.newsReaction = Object.assign(state.newsReaction, action.payload);
        },
        setShowCommentModal: (state, action) => {
            state.showCommentModal = action.payload;
        },
        setCommentId: (state, action) => {
            state.commentId = action.payload;
        },
    },
});

export const newsState = (state) => state.news;

export const { setNewsReaction, setShowCommentModal, setCommentId } = newsSlice.actions;

export default newsSlice.reducer;
